<template>
  <div class="mt-5 homapt-expandable card h-100">
    <div class="frame" v-bind:style="image" v-bind:class="{'cover-image': profileImage, 'contain-image': !profileImage}"></div>
    <div class="card-body">
      <h5 class="card-title">{{ title }}</h5>
      <p v-if="rating">Rating: {{ rating }}</p>
    </div>
    <div class="row">
      <div class="left-col col-4 my-auto small-margin">
        <img v-if="costLevel" v-bind:src="costLevelImage.image">
      </div>
      <div class="center-col col-4 my-auto small-margin">
        <img v-if="availabilityLevel" v-bind:src="availabilityImage.image">
      </div>
      <div class="right-col col-4 my-auto small-margin">
        <!--<img src="/static/15.png">-->
      </div>
    </div>
    <div class="card-footer">
      <b-button variant="primary" class="learn-more-button"  v-bind:to='idPath'>Learn More</b-button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    data: Object
  },
  computed: {
    businessId () {
      if (this.data.hasOwnProperty('businessId')) {
        return this.data.businessId
      } else if (this.data.hasOwnProperty('business_id')) {
        return this.data.business_id
      } else {
        return null
      }
    },
    title () {
      if (this.data.hasOwnProperty('title')) {
        return this.data.title
      } else if (this.data.hasOwnProperty('display_name')) {
        return this.data.display_name
      } else {
        return null
      }
    },
    rating () {
      if (this.data.hasOwnProperty('rating')) {
        return this.data.rating
      } else {
        return null
      }
    },
    profileImage () {
      if (this.data.hasOwnProperty('profile_image')) {
        return this.data.profile_image
      } else if (this.data.hasOwnProperty('profileImage')) {
        return this.data.profileImage
      } else {
        return null
      }
    },
    google () {
      if (this.data.hasOwnProperty('google')) {
        return this.data.google
      } else {
        return false
      }
    },
    costLevel () {
      if (this.data.hasOwnProperty('cost_level')) {
        return this.data.cost_level
      } else if (this.data.hasOwnProperty('costLevel')) {
        return this.data.costLevel
      } else {
        return null
      }
    },
    availabilityLevel () {
      if (this.data.hasOwnProperty('availability_level')) {
        return this.data.availability_level
      } else if (this.data.hasOwnProperty('availabilityLevel')) {
        return this.data.availabilityLevel
      } else {
        return null
      }
    },
    emergencies () {
      if (this.data.hasOwnProperty('emergencies')) {
        return this.data.emergencies
      } else {
        return null
      }
    },
    costLevelImage () {
      if (this.costLevel === '100') {
        return {
          image: '/static/20.png',
          text: ''
        }
      } else if (this.costLevel === '200') {
        return {
          image: '/static/21.png',
          text: ''
        }
      } else if (this.costLevel === '300') {
        return {
          image: '/static/22.png',
          text: ''
        }
      } else if (this.costLevel === '400') {
        return {
          image: '/static/23.png',
          text: ''
        }
      } else {
        return {
          image: null,
          text: ''
        }
      }
    },
    availabilityImage () {
      if (this.availabilityLevel === '100') {
        return {
          image: '/static/12.png',
          text: 'Available in: 0-2 weeks'
        }
      } else if (this.availabilityLevel === '200') {
        return {
          image: '/static/13.png',
          text: 'Available in: 1-2 months'
        }
      } else if (this.availabilityLevel === '300') {
        return {
          image: '/static/14.png',
          text: 'Available in: 2 months'
        }
      } else {
        return {
          image: null,
          text: ''
        }
      }
    },
    idPath () {
      return 'business/' + this.businessId + '/' + this.google + '/information'
    },
    image () {
      if (this.profileImage) {
        return 'background-image: url("https://s3.' +
               window.CONFIG.Region +
               '.amazonaws.com/' +
               window.CONFIG.PhotoBucketName +
               '/xsmall/' +
               this.businessId + '/' +
               this.profileImage + '")'
      } else {
        return 'background-image: url("../../../static/logo.svg")'
      }
    }
  }
}
</script>

<style scoped>
.card {
  border-radius: 10px;
}

.card-title {
  margin-bottom: 0px;
}

.card-body {
  padding-bottom: 0px;
}

.frame {
  border-radius: 8px;
  height: 230px;
  background: transparent no-repeat center;
  margin-top: 1rem;
  margin-left: 1rem;
  margin-right: 1rem;
}

.cover-image {
  background-size: cover;
}

.contain-image {
  background-size: contain;
}

img {
  padding-bottom: .5rem;
  padding-right: .5rem;
  padding-left: .5rem;
}

.card {
  margin: 1rem !important;
}

.left-col {
  padding-right: 0;
}

.center-col {
  padding-right: 0;
  padding-left: 0;
}

.right-col {
  padding-left: 0;
}

.small-margin {
  padding-left: .75rem;
  padding-right: .75rem;
}

.learn-more-button {
  margin-top: 0px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/marketplace/ServiceCard.vue